import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-856b0f1e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "resolving-limitation-step-two" }
const _hoisted_2 = {
  key: 0,
  class: "resolving-limitation-step-two__play-btn"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "61",
  height: "61"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    fill: "#FFF",
    d: "M30.637 60.221C14.114 60.221.672 46.78.672 30.256.672 13.731 14.114.29 30.637.29s29.966 13.441 29.966 29.966c0 16.524-13.443 29.965-29.966 29.965zm0-55.545c-14.105 0-25.58 11.473-25.58 25.58 0 14.106 11.475 25.58 25.58 25.58 14.105 0 25.58-11.474 25.58-25.58 0-14.107-11.475-25.58-25.58-25.58zm-1.085 35.772c-.956.397-2.048.773-3.073.773-.788 0-1.534-.222-2.145-.827-.474-.469-1.735-1.713-1.736-9.918-.003-8.668 1.306-9.961 1.736-10.387 1.534-1.51 4.021-.471 5.086-.028 1.517.634 12.18 6.101 12.18 10.195 0 3.817-9.595 9.167-12.048 10.192zm-2.176-16.516c-.519 2.921-.527 9.915-.009 12.693 2.565-.91 8.121-4.559 9.621-6.366-1.486-1.756-6.979-5.339-9.612-6.327z"
  })
], -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "resolving-limitation-step-two__title" }, " فایل ویدئویی شما آماده ارسال می باشد. "),
  /*#__PURE__*/_createElementVNode("div", { class: "resolving-limitation-step-two__description" }, " در صورتی که ویدئو ارسالی مطابق با راهنما تهیه شده است لطفا دکمه “تایید و ارسال “ را بزنید تا درخواست شما در صف بررسی توسط کارشناسان قرار گیرد. ")
], -1))
const _hoisted_7 = {
  key: 3,
  class: "d-flex w-100"
}
const _hoisted_8 = {
  class: "flex-grow-1 ml-2",
  style: {"margin-left":"10px"}
}
const _hoisted_9 = { class: "flex-grow-1" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "21",
  height: "21"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    fill: "#0668E1",
    d: "M20.282 7.886a.794.794 0 0 1-1.251.573L15.603 6.01a.792.792 0 1 1 .922-1.29l1.13.807a8.445 8.445 0 0 0-7.134-3.941c-3.236 0-6.103 1.844-7.531 4.641a.793.793 0 0 1-1.412-.722C3.265 2.201 6.664 0 10.521 0c3.585 0 6.679 1.871 8.462 4.671l.105-1.153a.792.792 0 1 1 1.579.144l-.385 4.224zM2.01 11.841l3.429 2.449a.793.793 0 0 1-.922 1.29l-1.131-.807a8.45 8.45 0 0 0 7.135 3.941c3.235 0 6.103-1.845 7.531-4.641a.792.792 0 1 1 1.412.722c-1.687 3.304-5.086 5.505-8.943 5.505-3.585 0-6.679-1.871-8.462-4.671l-.105 1.153a.794.794 0 0 1-1.579-.144l.385-4.224a.793.793 0 0 1 1.25-.573z"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_alert = _resolveComponent("alert")!
  const _component_upload_progress_bar = _resolveComponent("upload-progress-bar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.errorMessage)
      ? (_openBlock(), _createBlock(_component_alert, {
          key: 0,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.errorMessage = undefined)),
          variant: "danger",
          title: _ctx.errorMessage
        }, null, 8, ["title"]))
      : _createCommentVNode("", true),
    (_ctx.successAlert)
      ? (_openBlock(), _createBlock(_component_alert, {
          key: 1,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.successAlert = false)),
          variant: "success",
          title: "با موفقیت انجام شد!",
          content: "درخواست رفع محدودیت شما با موفقیت ارسال و در صف بررسی توسط کارشناسان قرار گرفت شد."
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass([
        'resolving-limitation-step-two__player',
        !_ctx.isVideoPlaying && 'resolving-limitation-step-two__player--overlay',
      ]),
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.play && _ctx.play(...args)))
    }, [
      (!_ctx.isVideoPlaying)
        ? (_openBlock(), _createElementBlock("button", _hoisted_2, _hoisted_4))
        : _createCommentVNode("", true),
      _createElementVNode("video", {
        ref: "videoRef",
        class: "resolving-limitation-step-two__video",
        src: _ctx.playerSrc
      }, null, 8, _hoisted_5)
    ], 2),
    _hoisted_6,
    (_ctx.isVideoUploading)
      ? (_openBlock(), _createBlock(_component_upload_progress_bar, {
          key: 2,
          percentage: _ctx.percentage
        }, null, 8, ["percentage"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.upload && _ctx.upload(...args))),
              type: "submit",
              class: "btn btn-primary w-100 block ml-2"
            }, " تایید و ارسال ")
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('back'))),
              class: "btn btn-light-primary w-100 block"
            }, [
              _hoisted_10,
              _createTextVNode(" ضبط دوباره ")
            ])
          ])
        ]))
  ]))
}